<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<h3 class="mt-1">Crea nuovo cliente</h3>

<p 
  class="small text-muted">
  I campi contrassegnati da * sono obbligatori.
</p>

  <!-- <p>Aggiunta rapida:</p>
  <button matButton="elevated" (click)="openDialog()">Aggiunta rapida</button>
    <p>Aggiunta:</p> -->

<form #CompanyForm="ngForm" (ngSubmit)="addNewCompany()" class="company-form">

<mat-card class="mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card">
  <mat-card-content>

        <h5 class="mb-3">Nuovo cliente:</h5>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Nome cliente</mat-label>
            <input
              matInput
              [(ngModel)]="newCompany.company_name"
              name="company_name"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Tipo</mat-label>
            <mat-select
              [(ngModel)]="newCompany.type"
              name="type"
              required
            >
              <mat-option *ngFor="let type of typeOptions" [value]="type.code">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>P. IVA</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.iva_number"
              name="iva_number"
              minlength="11"
              maxlength="11"
              pattern="[0-9]*"
              (ngModelChange)="onPartitaIvaChange($event)"
              (input)="onPartitaIvaInput($event)"
              (blur)="validatePartitaIva(newCompany.iva_number)"
              #iva_numberInput="ngModel"
            />
            <mat-error *ngIf="iva_numberInput.invalid && (iva_numberInput.dirty || iva_numberInput.touched)">
              La Partita Iva deve essere composta esattamente da 11 cifre
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Codice Fiscale</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.c_f"
              name="c_f"
              maxlength="16"
              pattern="([A-Z0-9]{11}|[A-Z0-9]{16})"
              #CFInput="ngModel"
            />
            <mat-error *ngIf="CFInput.invalid && (CFInput.dirty || CFInput.touched)">
              Il Codice Fiscale deve essere composto esattamente da 11 o 16 caratteri alfanumerici
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Codice destinatario SDI</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.addressee_code"
              name="addressee_code"
              required
              minlength="6"
              maxlength="7"
              pattern="^[A-Z0-9]*"
              #SDI_CodeInput="ngModel"
            />
            <mat-error *ngIf="SDI_CodeInput.invalid && (SDI_CodeInput.dirty || SDI_CodeInput.touched)">
              Il Codice SDI deve essere composto esattamente da 6 o 7 caratteri alfanumerici maiuscoli
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Codice interno (opzionale)</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.internal_code"
              name="internal_code"
            />
          </mat-form-field>
        </div>

  </mat-card-content>
</mat-card>

<mat-card class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card">
  <mat-card-content>

    <h5 class="mb-3">Dati anagrafici:</h5>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Indirizzo</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.address"
              name="address"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Città</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.city"
              name="city"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Comune</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.comune"
              name="comune"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>CAP</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.cap"
              name="cap"
              required
              minlength="5"
              maxlength="5"
              pattern="[0-9]*"
              #CAP_CodeInput="ngModel"
            />
            <mat-error *ngIf="CAP_CodeInput.invalid && (CAP_CodeInput.dirty || CAP_CodeInput.touched)">
              Il CAP deve essere composto esattamente da 5 cifre
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="row">
          <!-- <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Provincia</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.province"
              name="province"
              required
            />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
            <mat-label>Provincia (sigla)</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="newCompany.province"
              name="province"
              required
              minlength="2"
              maxlength="2"
              pattern="[A-Z]*"
              (ngModelChange)="onProvinceChange($event)"
              (input)="onProvinceInput($event)"
              (blur)="validateProvince(newCompany.province)"
              #provinceInput="ngModel"
            />
            <mat-error *ngIf="provinceError">
              {{ provinceError }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Nazione</mat-label>
            <mat-select 
              [(ngModel)]="newCompany.country"
              name="type"
              required
              >
              <mat-option *ngFor="let country of countryOptions" [value]="country.code">
                {{ country.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Codice Ateco</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.ateco_code"
              name="ateco_code"
            />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Telefono</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.telephone"
              name="telephone"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Cellulare</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.cellphone"
              name="cellphone"
            />
          </mat-form-field>
        </div>

        <div class="row">
          <!-- <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Codice fiscale</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.c_f"
              name="c_f"
              required
            />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>Email</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.email_address"
              name="email_address"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-25">
            <mat-label>PEC</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newCompany.pec"
              name="pec"
            />
          </mat-form-field>
          
        </div>
        
        <div class="row">
          <p> Note:</p>
          <mat-form-field appearance="outline" class="w-sm-50">
            <mat-label>Note</mat-label>
            <textarea 
              matInput
              type="string"
              [(ngModel)]="newCompany.notes"
              name="notes"></textarea>
          </mat-form-field>
        </div>

        <div class="d-flex flex-column">
          <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="!CompanyForm.valid"
              class="mt-3 align-self-end"
            >
            <mat-icon>person_add</mat-icon>
              Aggiungi cliente
          </button>
        </div>

  </mat-card-content>
</mat-card>

<div class="pt-3 mb-3"></div>

</form>
